/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */
//$('.product-form__single-selector[data-option-position="1"] option:first-child').attr('');

$(document).ready(function(){

 if( typeof(productOptions ) != "undefined" ){
    for(i=0;i<productOptions.length;i++) {
      $('.product-form__single-selector:eq('+ i +')')
      .filter(function() {
        return $(this).find('option').length > 0
      })
      .prepend('<option value="">Pick a ' + productOptions[i][i] + '</option>')
      .val('')
      .trigger('change');
    }
  }
  $('label.product-form__option-name.text--strong span.product-form__selected-value').text('');

  
$('.cstm-slider').slick({
  dots: true,
  infinite: true,
  arrow:false,
  speed: 300,
  slidesToShow: 3,
  slidesToScroll: 1,
    responsive: [
    {
      breakpoint: 999,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        infinite: true
      }
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]

});
  
  var mediaScreen = $(window).width();
  if(mediaScreen < 999)  { 
$('.cstm-payment-slider').slick({
  dots: false,
  infinite: true,
  arrow:true,
  speed: 300,
  slidesToShow: 5,
  slidesToScroll: 1,
    prevArrow:'<button class="slick-prev slick-arrow" aria-label="Previous" type="button" style=""><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M15 18L9 12L15 6" stroke="black" stroke-width="0.83" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
    nextArrow:'<button class="slick-next slick-arrow" aria-label="Next" type="button" style=""><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M9 18L15 12L9 6" stroke="black" stroke-width="0.83" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
    
  responsive: [
    {
      breakpoint: 999,
      settings: {
        slidesToShow: 5,
        slidesToScroll: 1,
        infinite: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1
      }
    }
  ]
});
 } else { }
  
 var mediaScreen = $(window).width();
  if(mediaScreen < 999)  { 
$('.cstm-collection-list').slick({
  dots: false,
  adaptiveHeight: true,
  infinite: false,
  arrow:true,
  speed: 300,
  slidesToShow: 3,
  slidesToScroll: 1,
    prevArrow:'<button class="slick-prev slick-arrow" aria-label="Previous" type="button" style=""><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M15 18L9 12L15 6" stroke="black" stroke-width="0.83" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
    nextArrow:'<button class="slick-next slick-arrow" aria-label="Next" type="button" style=""><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M9 18L15 12L9 6" stroke="black" stroke-width="0.83" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
    
  responsive: [
    {
      breakpoint: 999,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
    adaptiveHeight: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    }
  ]
});
 } else { }

$('.cstm-collection-lists').slick({
  dots: false,
  adaptiveHeight: true,
  infinite: false,
  arrow:true,
  speed: 300,
  slidesToShow: 5,
  slidesToScroll: 1,
    prevArrow:'<button class="slick-prev slick-arrow" aria-label="Previous" type="button" style=""><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M15 18L9 12L15 6" stroke="black" stroke-width="0.83" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
    nextArrow:'<button class="slick-next slick-arrow" aria-label="Next" type="button" style=""><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M9 18L15 12L9 6" stroke="black" stroke-width="0.83" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
    
  responsive: [
    {
      breakpoint: 999,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
    adaptiveHeight: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    }
  ]
});


  
});
